import { Files, InfoFiles } from '../../services/journey.service';
import { sliceToLimit, hasMoreThanLimit } from '../../lib/pagination';

export default class MyFilesV2Model {
  static mergeAllFiles(files: Files): InfoFiles[] {
    return [
      ...(files.requests ?? []),
      ...(files.reports ?? []),
      ...(files.surgicalReports ?? []),
      ...(files.surgicalVideos ?? []),
      ...(files.exams ?? [])
    ];
  }

  static sortByDate(files: InfoFiles[]): InfoFiles[] {
    return [...files].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }

  static filterByYear(files: InfoFiles[], year: string): InfoFiles[] {
    return files.filter(f => new Date(f.date).getFullYear().toString() === year);
  }

  static extractYears(files: InfoFiles[]): string[] {
    const years = files.map(f => new Date(f.date).getFullYear().toString());
    return Array.from(new Set(years)).sort((a, b) => Number(a) - Number(b));
  }

  static getPage(files: InfoFiles[], page: number, pageSize = 10): InfoFiles[] {
    return sliceToLimit(files, page * pageSize);
  }

  static hasMore(files: InfoFiles[], page: number, pageSize = 10): boolean {
    return hasMoreThanLimit(files.length, page * pageSize);
  }
}
